import { render, staticRenderFns } from "./FormDadosContato.vue?vue&type=template&id=b21a4466&"
import script from "./FormDadosContato.vue?vue&type=script&lang=js&"
export * from "./FormDadosContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports